export { default as SuggestedServicesList } from './SuggestedServicesList';
